import $ from 'jquery';
import debug from 'debug';
import plugin from '@core/plugins/lib';

const ELEMENT_SELECTOR = '[data-header-controller]';
const PLUGIN_NAME = 'headerController';

const log = debug('site-header/header-controller:header');

class HeaderController {
	constructor(element, options) {
		log('element', element);
		log('options', options);

		this.options = options;
		this.element = element;
		this.$element = $(element);

		this.isSearchCollapsible = !!this.options.searchComponentSelector;

		this.searchComponent = this.isSearchCollapsible && this.selectors.selectTarget(
			this.options.searchComponentSelector,
			this.$element
		);

		this.phoneComponent = this.selectors.selectTarget(
			this.options.phoneComponentSelector,
			this.$element
		);



		this.watch();

		log('ready', this, this.$target);
	}

	watch() {
		log('watching');

		this.$element.on('concealsearch', this.tryConcealSearch.bind(this));
		this.$element.on('closephone', this.closePhoneComponent.bind(this));
	}

	closePhoneComponent(){
		if (this.phoneComponent.length) {
			this.phoneComponent[0].dataset.collapsibleOpen = false;
		}
	}

	tryConcealSearch(){
		log('attempting to disable search');
		if (this.isSearchCollapsible) {
			this.searchComponent.trigger('disablesearch');
		} else {
			log('Search is not collapsible');
		}
	}


}

HeaderController.DEFAULTS = {};

plugin(PLUGIN_NAME, HeaderController);

$(document).ready(() => {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});




// WEBPACK FOOTER //
// ./project/client/src/core/components/site-header/site-header-controller.js